import { Block } from "Content/Block";
import {
  CaptchaInvalidLabel,
  ContactCheckboxContainer,
  ContactInput,
  ContactSubmit,
  ContactTextarea,
  Spinner,
  SpinnerContainer,
  StyledContact,
  StyledForm,
} from "./style";
import { Captcha } from "./Captcha";
import { useEffect, useState } from "react";
import axios from "axios";

function getRandom(min, max) {
  return Math.random() * (max - min) + min;
}

const generateCaptcha = () => {
  var chars = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "J",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "j",
    "k",
    "m",
    "n",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
  ];
  let tmpCaptcha = "";
  for (var i = 0; i < 6; i++) {
    var charIdx = Math.floor(getRandom(0, chars.length - 1), 1);
    tmpCaptcha = `${tmpCaptcha}${chars[charIdx]}`;
  }

  return tmpCaptcha;
};

export const Contact = ({ setModalDialog }) => {
  const [currentCaptcha, setCurrentCaptcha] = useState(generateCaptcha());

  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [subject, setSubject] = useState("");
  const [date, setDate] = useState("");
  const [location, setLocation] = useState("");
  const [message, setMessage] = useState("");
  const [captcha, setCaptcha] = useState("");
  const [captchaInvalid, setCaptchaInvalid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [privacyAccepted, setPrivacyAccepted] = useState(false);

  useEffect(() => {
    if (alertMessage !== undefined && alertMessage.length > 0) {
      alert(alertMessage);
    }
  }, [alertMessage]);

  useEffect(() => {
    console.log("captcha invalid: " + captchaInvalid);
  }, [captchaInvalid]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (captcha !== currentCaptcha) {
      setCaptchaInvalid(true);
      console.log("captcha invalid");
      return;
    }

    const data = {
      service_id: "jenni-hair-makeup",
      template_id: "template_5l0e6yt",
      user_id: "niERPbQsE_a2KOA6-",
      template_params: {
        name: name,
        email: "info@jenni-hairmakeup.de",
        mail: mail,
        message: message,
        subject: subject,
        date: date,
        location: location,
      },
    };

    setIsLoading(true);

    axios
      .post("https://api.emailjs.com/api/v1.0/email/send", {
        ...data,
      })
      .then(function (response) {
        setIsLoading(false);
        setName("");
        setMail("");
        setSubject("");
        setDate("");
        setLocation("");
        setMessage("");
        setPrivacyAccepted(false);
        setCaptcha("");
        setCurrentCaptcha(generateCaptcha());
        setCaptchaInvalid(false);
        setAlertMessage(
          "Vielen Dank für deine Anfrage! Eine Bestätigungsmail wurde an die von dir angegebene E-Mail Adresse versendet! :)"
        );
      })
      .catch(function (error) {
        setIsLoading(false);
        setAlertMessage("Leider ist ein Fehler aufgetreten. ");
      });
  };

  return (
    <div id="contact">
      <Block caption={"Kontakt"}>
        <StyledContact>
          <StyledForm onSubmit={handleSubmit}>
            <div>Name:</div>
            <ContactInput
              name="name"
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <div>E-Mail:</div>
            <ContactInput
              name="email"
              type="email"
              required
              value={mail}
              onChange={(e) => setMail(e.target.value)}
            />
            <div>Betreff:</div>
            <ContactInput
              name="subject"
              required
              autocomplete="off"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
            />
            <div>Datum des Stylings:</div>
            <ContactInput
              name="subject"
              autocomplete="off"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              type="date"
            />
            <div>Ort des Stylings:</div>
            <ContactInput
              name="subject"
              autocomplete="off"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
            <div>Nachricht:</div>
            <ContactTextarea
              name="message"
              required
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></ContactTextarea>
            <ContactCheckboxContainer>
              <ContactInput
                required
                type="checkbox"
                name="check-data"
                id="check-data"
                value={privacyAccepted}
                onChange={(e) => setPrivacyAccepted(e.target.value)}
              />
              <label htmlFor="check-data">
                Ich bin damit einverstanden, dass ich unter der von mir
                angegebenen E-Mail Adresse kontaktiert werden darf und
                akzeptiere unsere{" "}
                <a onClick={() => setModalDialog("dataProtection")}>
                  Datenschutzerklärung
                </a>
              </label>
            </ContactCheckboxContainer>
            <Captcha captcha={currentCaptcha} />
            <ContactInput
              name="captcha"
              required
              autocomplete="off"
              value={captcha}
              invalid={captchaInvalid}
              onChange={(e) => setCaptcha(e.target.value)}
            />
            {captchaInvalid && (
              <CaptchaInvalidLabel>
                <p>Der eingegebene Sicherheitscode ist leider falsch</p>
              </CaptchaInvalidLabel>
            )}
            {isLoading && (
              <SpinnerContainer>
                <Spinner />
              </SpinnerContainer>
            )}
            {!isLoading && (
              <ContactSubmit type="submit" captchaInvalid={captchaInvalid} />
            )}
          </StyledForm>
        </StyledContact>
      </Block>
    </div>
  );
};
